class CtrlZDamageSlider extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('[data-slider-container]');
    this.handle = this.querySelector('[data-slider-handle]');

    if (!this.container || !this.handle) return;

    const initial = this.style.getPropertyValue('--slider-position') || '50%';
    this._position = parseFloat(initial) || 50;

    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp = this._onPointerUp.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);

    // Listen on container so drag works anywhere on the image, not just the handle
    this.container.addEventListener('pointerdown', this._onPointerDown);
    this.handle.addEventListener('keydown', this._onKeyDown);
  }

  disconnectedCallback() {
    this.container?.removeEventListener('pointerdown', this._onPointerDown);
    this.handle?.removeEventListener('keydown', this._onKeyDown);
    this._stopDrag();
  }

  _onPointerDown(event) {
    event.preventDefault();
    this.handle.focus();
    this.container.setPointerCapture(event.pointerId);
    this.container.addEventListener('pointermove', this._onPointerMove);
    this.container.addEventListener('pointerup', this._onPointerUp);
    this.container.addEventListener('pointercancel', this._onPointerUp);
  }

  _onPointerMove(event) {
    const { left, width } = this.container.getBoundingClientRect();
    const percent = ((event.clientX - left) / width) * 100;
    this.setPosition(percent);
  }

  _onPointerUp(event) {
    this.container.releasePointerCapture(event.pointerId);
    this._stopDrag();
  }

  _stopDrag() {
    this.container?.removeEventListener('pointermove', this._onPointerMove);
    this.container?.removeEventListener('pointerup', this._onPointerUp);
    this.container?.removeEventListener('pointercancel', this._onPointerUp);
  }

  _onKeyDown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    const STEP = 5;
    const delta = event.key === 'ArrowLeft' ? -STEP : STEP;
    this.setPosition(this._position + delta);
  }

  setPosition(percent) {
    const clamped = Math.min(100, Math.max(0, percent));
    this._position = clamped;
    // Only permitted element.style usage: CSS custom property for dynamic slider position
    this.style.setProperty('--slider-position', `${clamped}%`);
  }
}

if (!customElements.get('ctrl-z-damage-slider')) {
  customElements.define('ctrl-z-damage-slider', CtrlZDamageSlider);
}
